export enum ReduceFunds {
  NONE = 'NONE',
  TECHNOLOGY = 'TECHNOLOGY',
  SUPPLEMENTAL = 'SUPPLEMENTAL',
}
